'use client';

import { useApi } from '@prismo-io/core';
import useSWR from 'swr';
import { fetchFormations } from '../../../utils/fetch-formations';

export const useFormationsSidebar = () => {
  const { client } = useApi();

  return useSWR('formation-quark-sidebar', async () => {
    const {
      data: { session },
    } = await client.auth.getSession();

    if (!session) {
      throw new Error('');
    }

    return fetchFormations(client, session.user.id);
  });
};
